import { createRef } from "react";

export const languages = createRef([]);
export const defaultLanguage = createRef("en");